import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Innovacrystaonrentinmumbai() {



const cardData = {
  keyword: " Innova Crysta on Rent in Mumbai",

headingDescription:
  "Omshree Cab offers premium Innova Crysta on rent in Mumbai for travelers seeking a spacious, comfortable, and stylish ride for city travel, outstation trips, airport transfers, family vacations, and corporate travel. The **Toyota Innova Crysta** is known for its refined interiors, smooth performance, and ample seating, making it ideal for groups, long journeys, and luxury travel needs. Our flexible rental options include one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. Each Innova Crysta in our fleet is well‑maintained, air‑conditioned, and driven by professional chauffeurs experienced with Mumbai’s routes and traffic conditions. With easy online booking, punctual pickups from any location in Mumbai (including the airport, railway stations, hotels, and residential addresses), and 24/7 customer support, renting an Innova Crysta in Mumbai is convenient, comfortable, and stress‑free.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks, situated along the Arabian Sea in South Mumbai. Visitors enjoy admiring the majestic architecture, capturing photographs, and taking ferry rides to Elephanta Island. The surrounding Colaba area also features lively cafes, historic buildings, and street markets. Renting an Innova Crysta makes it comfortable for families and groups to reach this famous destination without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road stretching along the Arabian Sea, famously called the Queen’s Necklace because of its glittering lights at night. Visitors come here for evening walks, sunset views, and relaxing sea breezes. The long promenade connects several important parts of South Mumbai, making it a popular route for city sightseeing. A spacious Innova Crysta rental ensures a smooth, comfortable journey for larger groups or family outings along this iconic stretch."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, known for its sandy shores, sunset views, and lively street food culture featuring pav bhaji, bhel puri, and pani puri. Families and friends often visit to relax and enjoy the sea breeze. Renting an Innova Crysta provides ample seating and storage for beach gear, making the trip comfortable and enjoyable."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a renowned Hindu temple in Mumbai dedicated to Lord Ganesha, attracting devotees from across India. The temple’s spiritual ambiance and beautiful architecture make it a key destination for visitors. Festivals like Ganesh Chaturthi draw large crowds, making parking and traffic challenging. Renting an Innova Crysta ensures a stress‑free and comfortable ride, especially for families and groups visiting this sacred site."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern engineering marvel connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the water and city skyline, especially during sunset and evening hours when the lights create a spectacular scene. Many travelers enjoy driving across the Sea Link for scenic views and photography. Renting an Innova Crysta ensures comfortable travel while exploring this landmark with family or friends."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the coast of Mumbai, known for its serene environment and spiritual significance. The white marble structure stands peacefully amid the Arabian Sea and attracts visitors of various faiths. Renting an Innova Crysta provides a comfortable and convenient journey to this spiritual destination without the hassle of navigating city traffic or parking challenges."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island in Mumbai Harbour, known for their incredible sculptures dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract tourists interested in history, culture, and architecture. Visitors usually take a ferry from the Gateway of India to reach the island. Renting an Innova Crysta allows tourists to comfortably reach the ferry departure point and begin their visit without worrying about logistics."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast forest reserve within Mumbai offering trekking, nature walks, wildlife spotting, and the historic Kanheri Caves. Nature lovers and families visit this green oasis to enjoy outdoor activities and scenic trails. Renting an Innova Crysta provides a spacious and comfortable ride, making it easy to plan a full‑day trip to the park with friends or family."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai known for its vibrant markets, boutiques, and local eateries. Visitors can shop for clothing, accessories, handicrafts, and souvenirs while experiencing the local culture. Renting an Innova Crysta ensures a comfortable travel experience to this lively market area and back, especially when traveling with family or a group."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens located on Malabar Hill, offering panoramic views of Marine Drive and the Arabian Sea. The gardens are a great spot for relaxing walks, photography, and unwinding amidst greenery. Renting an Innova Crysta provides convenient and comfortable access for families or groups planning to include this scenic spot in their Mumbai itinerary."
  }
],



services: [
{
name: "Innova Crysta on Rent Mumbai",
description: "Innova Crysta on rent in Mumbai offers premium MPV transportation for passengers looking for spacious and comfortable travel. The Toyota Innova Crysta is known for its luxurious interiors, powerful performance, and smooth ride quality. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family travel, corporate trips, and long-distance journeys. Large seating capacity ensures comfortable travel for groups. Flexible booking options allow quick and easy reservations anytime."
},
{
name: "Innova Crysta Rental Mumbai",
description: "Innova Crysta rental in Mumbai provides reliable and luxurious transportation for passengers traveling within the city or to nearby destinations. The vehicle offers spacious seating, strong engine performance, and smooth suspension suitable for highways. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, and transport hubs across Mumbai. Ideal for corporate travel, tourism visits, and family trips. Comfortable AC interiors ensure relaxed journeys for passengers. Easy booking options allow convenient ride scheduling."
},
{
name: "Innova Crysta Cab Service Mumbai",
description: "Innova Crysta cab service in Mumbai provides premium travel using spacious Toyota Innova Crysta vehicles. These vehicles offer superior comfort, large seating capacity, and smooth highway performance. Professional drivers ensure punctual pickup and safe driving services for every ride. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for airport transfers, corporate travel, and family tours. Comfortable interiors ensure relaxing journeys for passengers. Flexible booking options allow quick reservations."
},
{
name: "Innova Crysta Taxi Mumbai",
description: "Innova Crysta taxi in Mumbai offers luxurious MPV transportation for passengers seeking comfortable city and outstation travel. The vehicle provides spacious seating and excellent performance on highways. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for business trips, family travel, and tourism visits. Air-conditioned interiors ensure comfortable rides throughout the journey. Easy ride booking options allow convenient travel planning."
},
{
name: "Innova Crysta Hire Mumbai",
description: "Innova Crysta hire in Mumbai provides comfortable and premium transportation for passengers traveling across the city and nearby destinations. Toyota Innova Crysta vehicles offer spacious seating and smooth suspension for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family tours, business travel, and group trips. Large luggage space ensures convenience for travelers. Flexible hiring options allow easy ride scheduling."
},
{
name: "Luxury Innova Crysta Cab Mumbai",
description: "Luxury Innova Crysta cab in Mumbai offers premium travel experience for passengers who prefer high-end transportation. The vehicle provides plush seating, powerful performance, and smooth highway travel. Professional drivers ensure punctual pickup and professional service for every ride. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for corporate executives, VIP travel, and luxury family trips. Comfortable AC interiors ensure relaxed journeys during travel. Flexible booking options allow quick ride reservations."
},
{
name: "Innova Crysta Airport Cab Mumbai",
description: "Innova Crysta airport cab in Mumbai provides reliable airport transportation with spacious seating and luggage capacity. The vehicle ensures comfortable travel between airport terminals and city locations. Professional drivers monitor flight schedules to provide punctual pickup and drop services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned interiors ensure comfortable rides with luggage. Flexible booking options allow advance airport reservations."
},
{
name: "Innova Crysta Outstation Cab Mumbai",
description: "Innova Crysta outstation cab in Mumbai offers comfortable long-distance travel for passengers visiting destinations outside the city. The vehicle provides smooth highway performance and spacious seating ideal for extended journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, offices, and hotels. Ideal for pilgrimage tours, weekend trips, and family vacations. Large luggage space ensures convenient travel. Flexible one-way and round-trip booking options make travel planning easy."
},
{
name: "Innova Crysta One Way Cab Mumbai",
description: "Innova Crysta one way cab in Mumbai offers economical travel for passengers who require transportation without return charges. The vehicle provides comfortable seating and smooth travel on highways and city roads. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for intercity travel, business trips, and tourism visits. Spacious interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride reservations."
},
{
name: "Innova Crysta Round Trip Taxi Mumbai",
description: "Innova Crysta round trip taxi in Mumbai provides convenient travel for passengers planning return journeys to nearby destinations. The vehicle offers spacious seating and powerful performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family tours, weekend trips, and business travel. Comfortable interiors ensure relaxing journeys throughout the trip. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Cheap Innova Crysta Rental Mumbai",
description: "Cheap Innova Crysta rental in Mumbai offers affordable luxury transportation for passengers looking for comfortable group travel. Toyota Innova Crysta vehicles provide spacious seating and smooth travel for city and outstation journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, corporate rides, and airport transfers. Comfortable AC interiors ensure relaxed journeys. Flexible rental options allow easy booking anytime."
},
{
name: "Innova Crysta Corporate Cab Mumbai",
description: "Innova Crysta corporate cab in Mumbai provides premium transportation for business executives and corporate teams. The vehicle offers comfortable seating and professional travel suitable for office transfers and meetings. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from offices, hotels, airports, and business districts across Mumbai. Ideal for corporate events, airport transfers, and executive travel. Spacious interiors ensure comfortable rides for professionals. Flexible booking options allow scheduled corporate trips."
},
{
name: "Innova Crysta Family Cab Mumbai",
description: "Innova Crysta family cab in Mumbai provides spacious transportation ideal for families traveling together. The vehicle offers comfortable seating and smooth travel suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for family vacations, temple visits, and weekend trips. Large luggage space ensures convenient travel with bags. Flexible booking options allow easy ride reservations."
},
{
name: "Innova Crysta Per Km Rate Mumbai",
description: "Innova Crysta per km rate in Mumbai offers transparent pricing for passengers traveling in luxurious Toyota Innova Crysta vehicles. The vehicle provides spacious seating and smooth highway travel for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for outstation trips, corporate travel, and family tours. Comfortable interiors ensure relaxing journeys for passengers. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Innova Crysta Cab Booking Mumbai",
description: "Innova Crysta cab booking in Mumbai allows passengers to easily reserve luxurious MPV transportation for city and outstation travel. Online and phone booking options provide quick ride confirmation. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for family travel, corporate trips, and airport transfers. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling anytime."
}
],

tableData: [
["Innova Crysta on Rent Mumbai","Innova Crysta Rental Mumbai"],
["Innova Crysta Cab Service Mumbai","Innova Crysta Taxi Mumbai"],
["Innova Crysta Hire Mumbai","Luxury Innova Crysta Cab Mumbai"],
["Innova Crysta Airport Cab Mumbai","Innova Crysta Outstation Cab Mumbai"],
["Innova Crysta One Way Cab Mumbai","Innova Crysta Round Trip Taxi Mumbai"],
["Cheap Innova Crysta Rental Mumbai","Innova Crysta Corporate Cab Mumbai"],
["Innova Crysta Family Cab Mumbai","Innova Crysta Per Km Rate Mumbai"],
["Innova Crysta Cab Booking Mumbai","Toyota Innova Crysta Hire Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Luxury & Spacious Innova Crysta",
    WhyChoosedescription: "Toyota Innova Crysta is one of the most preferred luxury MPVs for travel in Mumbai. It offers spacious seating, premium interiors, and excellent comfort for families, corporate travelers, and group journeys."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and transparent pricing for Innova Crysta rentals in Mumbai. Customers receive complete details about per-kilometer rates, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Innova Crysta Availability",
    WhyChoosedescription: "Our Innova Crysta rental service in Mumbai operates 24 hours a day. Whether you need an early morning airport transfer or a late-night pickup, Omshree Cabs ensures reliable travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles in our fleet are regularly serviced, cleaned, and sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Perfect for Local & Outstation Travel",
    WhyChoosedescription: "Innova Crysta is ideal for local sightseeing in Mumbai as well as long-distance trips to Pune, Lonavala, Nashik, Shirdi, Surat, Mahabaleshwar, and other destinations."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai roads, highways, and ghat routes. They ensure safe driving and a smooth journey for passengers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai for hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted Premium Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Innova Crysta rentals in Mumbai because of our punctual service, luxury vehicles, and professional drivers."
  }
]
};

const faqData = [
  { question: "Do you provide Innova Crysta on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Toyota Innova Crysta rentals in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Innova Crysta?", answer: "Toyota Innova Crysta usually offers seating for 6 to 7 passengers, making it ideal for families and group travel." },
  { question: "Can I book Innova Crysta for Mumbai Airport transfer?", answer: "Yes, Innova Crysta is commonly used for Mumbai Airport pickup and drop services due to its spacious luggage capacity." },
  { question: "Is Innova Crysta suitable for long-distance travel?", answer: "Yes, Innova Crysta is highly comfortable for long-distance journeys and is commonly used for outstation travel from Mumbai." },
  { question: "Do you provide Innova Crysta for outstation trips?", answer: "Yes, we provide Innova Crysta rentals from Mumbai to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and many other cities." },
  { question: "Are Innova Crysta vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide drivers with the vehicle?", answer: "Yes, all Innova Crysta rentals include professional drivers experienced in city and highway travel." },
  { question: "Can I book Innova Crysta for full-day travel?", answer: "Yes, we offer full-day and multi-day rental packages for Innova Crysta in Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback:
      "We booked an Innova Crysta from Omshree Cabs for our Mumbai to Pune trip. The vehicle was very comfortable and the driver was professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Excellent Innova Crysta rental service in Mumbai. Spacious car, smooth ride, and very reliable service.",
    rating: 5
  }
];



















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Mumbai",
  "description": "Omshree Cab offers Innova Crysta on rent in Mumbai for local travel, airport transfers, outstation trips, one-way journeys, and round trips. Choose from luxury, family, and corporate cab options with affordable per km rates and easy online booking for a trusted Innova Crysta rental experience across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2900"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Innova Crysta on Rent in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Innova Crysta on rent in Mumbai for local travel, airport, outstation, one-way, and round trips. Luxury, family, and corporate cab options with affordable per km rates and easy online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinmumbai;